import React, { useEffect, useState } from 'react';
import { Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import { ApiService } from "../Components/Service/apiservices";
import constant from "../Components/Service/constant";

function InstaCard() {
    const [postData, setPostData] = useState([]);
    const [postImagePath, setPostImagePath] = useState('');

    useEffect(() => {
        getPostData();
    }, []);

    const getPostData = () => {
        ApiService.fetchData('instagram-post').then((res) => {
            if (res.status == 'success') {
                setPostData(res.getdata); // Corrected key from backend
                setPostImagePath(res.post_image_path);
            }
        });
    };

    
    return (
        <section className="insta_card">
            <Swiper
                modules={[Navigation, Autoplay]}
                spaceBetween={10}
                loop={true}
                speed={3000}
                autoplay={{
                    delay: 1500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    0: { slidesPerView: 1 },
                    576: { slidesPerView: 2 },
                    768: { slidesPerView: 2 },
                    991: { slidesPerView: 3 },
                    1200: { slidesPerView: 4 },
                }}
            >
                <SwiperSlide>
                    <div className="insta_item position-relative">
                        <div className="text-center">
                            <p>find us on instagram</p>
                            <h3 className="my-4">#PREMIOSTORIES</h3>
                            <Link to="https://www.instagram.com/premiobydhanvidiamond/" target="_blank" className="text-decoration-underline">
                                EXPLORE OUR INSTAGRAM
                            </Link>
                        </div>
                    </div>
                </SwiperSlide>

                {postData.map((value, index) => (
                    <SwiperSlide key={index}>
                        <div className="insta_item position-relative">
                            <Image
                                src={value.post_image ? postImagePath + value.post_image : constant.DEFAULT_IMAGE}
                                alt={value.post_name}
                            />
                            <div className="insta_item_txt position-absolute">
                                <a href={value.post_url} target="_blank" rel="noopener noreferrer" className="btn_fill">
                                    {value.post_name}
                                </a>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
}

export default InstaCard;
